// extracted by mini-css-extract-plugin
module.exports = {"container":"DropDownListTextHeader_container__1Kew0","content":"DropDownListTextHeader_content__3oAQD","sending":"DropDownListTextHeader_sending__1mOqG"};